import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ContentService } from '../services';
import * as moment from 'moment';
import { first } from 'rxjs/operators';


@Component({
  selector: 'app-home-card-config-header',
  templateUrl: './home-card-config-header.component.html',
  styleUrls: ['./home-card-config-header.component.scss']
})
export class HomeCardConfigHeaderComponent implements OnInit {

  @Input() contenttype: any;
  @Output() onHeaderChanged = new EventEmitter<any>();

  date: any;
  contentMode: any = "NOW";
  time: any = { hour: 23, minute: 59 };
  meridian = true;
  contentInfo: any;

  constructor(private contentService: ContentService) { }

  ngOnInit() {

    this.defDate();
    this.refreshMode();
  }

  defDate() {
    var d = new Date();
    this.date = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
  }

  refreshMode() {
    this.contentService.getContent(this.contenttype)
    .pipe(first())
    .subscribe(res => {
        this.contentInfo = res;
        if (!this.contentInfo.date) {
          this.contentInfo.date = moment(this.contentInfo.date, 'DD-MM-YYYY').toDate();
        }
        if (this.contentMode == 'LATER') {
          if (this.contentInfo) {
            for (var i = 0; i < this.contentInfo.length; i++) {
              if (this.contentInfo[i].content_mode == this.contentMode) {
                this.date = this.contentInfo[i].date;
                this.time = this.contentInfo[i].time;

                if (!this.date) {
                  this.defDate();
                  this.time = { hour: 23, minute: 59 };
                }
              }
            }
          }

          this.raiseEvent();
        }

      });
  }

  updateNow() {
    this.contentMode = "NOW";
    this.raiseEvent();
  }

  updateLater() {
    this.contentMode = "LATER";
    this.refreshMode();
  }

  onDateChanged() {
    //this.raiseEvent ();
  }

  onTimeChanged(x) {
    //this.raiseEvent ();
  }

  saveLaterTime() {
    if (this.date) {
      this.date = this.getDate(this.date);
    }

    this.contentService.saveContent(this.contentMode, this.contenttype, this.date, this.time)
    .pipe(first())
    .subscribe(res => {
        this.raiseEvent();
      });
  }

  raiseEvent() {

    var data = {
      contentMode: this.contentMode,
      date: this.date,
      time: this.time
    };

    this.onHeaderChanged.emit(data);
  }


  getDate(date) {
    return moment(date).format("DD-MM-YYYY").toString();
  }


}
